import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';

/**
 * Proto log filters
 */
export class ProtoLogFilters extends ApiRequestFilters {
	/**
	 * User IDs
	 */
	users?: number[];

	/**
	 * App subject enum values
	 */
	subjects?: AppSubjectEnum[];
}
